import React from 'react';
import PropTypes from 'prop-types';

const Toggle = ({ children, className, handleClick, selected }) => (
    <a
        className={className}
        onClick={handleClick}
        onKeyPress={handleClick}
        role="checkbox"
        aria-checked={selected}
        tabIndex="0"
    >
        {children}
    </a>
);

Toggle.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
    selected: PropTypes.bool
};

Toggle.defaultProps = {
    selected: false
};

export { Toggle };
